import { faCircle } from "@jewlr/pro-solid-svg-icons/faCircle"
import { faHeart as faHeartSolid } from "@jewlr/pro-solid-svg-icons/faHeart"
import { useState } from "react"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { jewlr_t } from "helpers/application"

import ConfettiCard from "./confetti-card"
import Coverage from "./coverage"
import JewlrExtend from "./jewlr-extend"
import LuxuryCollection from "./luxury-collection"
import SparkleWithConfidence from "./sparkle-with-confidence"
import WarrantyButtons from "./warranty-buttons"
import WarrantyDetails from "./warranty-details"
import WarrantyTerms from "./warranty-terms"

const voidWarrantyData = {
  children: (
    <>
      <p className="body mb-16">Certain things can void your warranty:</p>
      <ul className="m-0">
        <li>
          <p className="body">
            <b>Un{jewlr_t("terms.authorize")}d Repairs or Resizing:</b> Repairs
            or adjustments made by anyone other than Jewlr will void the
            warranty
          </p>
        </li>
        <li>
          <p className="body">
            <b>Improper Use:</b> If your piece is damaged due to improper
            handling or care, it won&apos;t be covered
          </p>
        </li>
      </ul>
    </>
  ),
  className: "bg-[#f7a7191a] border-citrine mb-32 desktop:mb-60",
  icon: faCircle,
  iconClassName: "text-citrine",
  title: "What Could Void Your Warranty",
}

const ExtendWarranty = () => {
  const [showExtend, setShowExtend] = useState(false)

  return (
    <>
      <div className="contained-wide widescreen:px-60 px-16">
        <h1 className="h1 mb-32">Jewlr Warranty Policy</h1>
        <SparkleWithConfidence />
        <WarrantyButtons setShowExtend={setShowExtend} />
        <Coverage />
        <WarrantyDetails />
        <ConfettiCard {...voidWarrantyData} />
        <WarrantyTerms />
      </div>
      <LuxuryCollection />

      {sl.config.enable_extend_warranty && (
        <JewlrExtend setShowExtend={setShowExtend} showExtend={showExtend} />
      )}

      <div className="bg-aquamarine desktop:py-60 widescreen:px-60 p-16 text-center">
        <FontAwesomeIcon
          className="text-primary text-32 desktop:mb-20 mb-8"
          icon={faHeartSolid}
        />
        <h2 className="h2">
          We want you to enjoy your Jewlr pieces for years to come!{" "}
          <br className="tablet:block hidden" />
          If you have questions or need assistance, our team is here to help.
        </h2>
      </div>
    </>
  )
}

export default ExtendWarranty
